export const workSetupOptions = [
  { id: 1, name: "On-site" },
  { id: 2, name: "Hybrid" },
  { id: 3, name: "Remote" },
];

export const EducationCertificateCard = ({ title, items, type }) => {
  return (
    <div className="card-section">
      <h3 className="card-title">
        {type === "education" ? (
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
            <path d="M5 13.18v4L12 21l7-3.82v-4L12 17l-7-3.82zM12 3L1 9l11 6 9-4.91V17h2V9L12 3z" />
          </svg>
        ) : (
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
            <path d="M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4zm-2 16l-4-4 1.41-1.41L10 14.17l6.59-6.59L18 9l-8 8z" />
          </svg>
        )}{" "}
        {title}
      </h3>

      {items?.length > 0 ? (
        items.map((item, index) => (
          <div key={index} className="card-item">
            {type === "education" ? (
              <>
                <p className="card-main">{item.degree}</p>
                <p className="card-sub">
                  Field of study: {item.field_of_study}
                </p>
                <p className="card-sub">Location: {item.location}</p>
              </>
            ) : (
              <>
                <p className="card-main">{item.certification_name}</p>
                <p className="card-sub">{item.issuing_organization}</p>
                {item.credential_url && (
                  <p className="card-sub">
                    <a
                      href={item.credential_url}
                      target="_blank"
                      rel="noreferrer"
                    >
                      Credential Link
                    </a>
                  </p>
                )}
                {item.credential_id && (
                  <p className="card-sub">
                    Credential ID: {item.credential_id}
                  </p>
                )}
              </>
            )}
          </div>
        ))
      ) : (
        <p>No {title.toLowerCase()} Details found</p>
      )}
    </div>
  );
};
